import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore as createSlice } from "redux";
import thunk from "redux-thunk";

import accessTokenCheck from "./middleware/accessTokenCheck";
import { loadState, saveState } from "./middleware/localStorageLoad";
import { makeRootReducer } from "./reducers";

const history = createBrowserHistory();

const createStore = () => {
	const persistedState = loadState();
	// ======================================================
	// Middleware Configuration
	// ======================================================
	const middleware = [thunk, accessTokenCheck, routerMiddleware(history)];

	// ======================================================
	// Store Enhancers
	// ======================================================
	const enhancers = [];
	let composeEnhancers = compose;

	if (process.env.NODE_ENV === "development") {
		// enable dev tools for dev evt
		if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function") {
			composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
		}
	}

	const store = createSlice(
		connectRouter(history)(makeRootReducer()),
		persistedState,
		composeEnhancers(applyMiddleware(...middleware), ...enhancers)
	);

	store.subscribe(() => {
		saveState(store.getState());
	});

	return store;
};

export default createStore;
